import { createSlice } from '@reduxjs/toolkit'
import {
  getActiveTemplate,
  getDefaultTemplate,
  homepageTemplates,
} from 'config/homepageConfig'

const initialState = {
  data: null,
  loading: false,
  template: getActiveTemplate(),
  availableTemplates: homepageTemplates,
  isTemplateSwitcherOpen: false,
}

const homepageSlice = createSlice({
  name: 'homepage',
  initialState,
  reducers: {
    setHomepageData: (state, action) => {
      state.data = action.payload
    },
    setHomepageLoading: (state, action) => {
      state.loading = action.payload
    },
    switchTemplate: (state, action) => {
      const templateId = action.payload
      const newTemplate = homepageTemplates[templateId]

      if (newTemplate) {
        state.template = newTemplate
        localStorage.setItem('homepageTemplate', templateId)
      }
    },
    toggleTemplateSwitcher: (state) => {
      state.isTemplateSwitcherOpen = !state.isTemplateSwitcherOpen
    },
    closeTemplateSwitcher: (state) => {
      state.isTemplateSwitcherOpen = false
    },
    initializeTemplate: (state, action) => {
      const { userRole, userProfile } = action.payload
      state.template = getDefaultTemplate(userRole, userProfile)
    },
  },
})

export const {
  setHomepageData,
  setHomepageLoading,
  switchTemplate,
  toggleTemplateSwitcher,
  closeTemplateSwitcher,
  initializeTemplate,
} = homepageSlice.actions

export default homepageSlice.reducer
